import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../profile/profile.service';
import { NotificationBuilder } from '../shared/notificationBuilder';
import { HelperService } from '../services/helper.service';
import { forkJoin, Observable } from 'rxjs';
import { Transparency } from '../models/transparency.model';
import { Configuration } from '../app.constants';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AuthenticationService } from '../authentication/authentication.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { HttpService } from '../services/http.service';
@Component({
  selector: 'app-transparency',
  templateUrl: './transparency.component.html',
  styleUrls: ['./transparency.component.css']
})

export class TransparencyComponent implements OnInit {
  uploadType: string
  loading: boolean
  transparency: Transparency
  icons: any
  isTransparencyPro: boolean = false //se for bloomer-5 pra cima
  filesToUpload: Array<File>
  selectedFileNames: string[] = []
  ticker: number
  idDelete: string
  isWarning = true;
  showWelcome: boolean = false
  step1: boolean = true;
  step2: boolean = false;
  public isLoadingData: Boolean = false
  constructor(private profileService: ProfileService, public ngxSmartModalService: NgxSmartModalService, private authenticationService: AuthenticationService, private http: HttpClient, public httpService : HttpService, private helperService: HelperService, private notificationBuilder: NotificationBuilder) {
    this.filesToUpload = [];
    this.selectedFileNames = [];
  }

  ngOnInit() {
    debugger
    this.ticker = new Date().getTime()
    this.isTransparencyPro = false;

    if (localStorage.getItem('showOnboarding') == null) {
      this.showOnboardingVideo();
      localStorage.setItem('showOnboarding', 'true')
    }

    this.requestDataFromMultipleSources().subscribe(([getTransparency]) => {
      this.transparency = getTransparency
      console.log(this.transparency)
      var plan = this.transparency.planSeoName;
      //If com os planos antigos para liberar as ferramentas da tela de high
      if (plan.indexOf('bloomer-4') >= 0 || plan.indexOf('bloomer-5') >= 0 || plan.indexOf('bloomer-5') >= 0 || plan.indexOf('bloomer-6') >= 0 || plan.indexOf('pollinator') >= 0 || plan.indexOf('percentual') >= 0) {
        this.isTransparencyPro = true
      }
      //If com os casos especificos para liberar as ferramentas da tela de high
      if (this.transparency.seoUrl == "puzzle-me" || this.transparency.seoUrl == "adoatelier" || this.transparency.seoUrl == "imobillenegocios-1" || this.transparency.seoUrl == "fom" || this.transparency.seoUrl == "stonedshop" || this.transparency.seoUrl == "loja-sotrackboa" || this.transparency.seoUrl == "nakednuts") {
        this.isTransparencyPro = true
      }
      //If com os planos novos para liberar as ferramentas da tela de high
      if (plan.indexOf('flower-4') >= 0 || plan.indexOf('flower-4-trimestral') >= 0 || plan.indexOf('flower-4-semestral') >= 0 || plan.indexOf('flower-4-anual') >= 0) {
        this.isTransparencyPro = true
      }
    })

  }

  requestDataFromMultipleSources(): Observable<any[]> {
    let getTransparency = this.profileService.getTransparency()
    return forkJoin([getTransparency]);
  }

  saveTransparency() {
    debugger
    var obj = this
    this.loading = true
    this.authenticationService.getFeatureList();
    this.profileService.updateTransparency(this.transparency).subscribe(data => {
      if (data) {
        if (this.filesToUpload.length > 0)
          if (this.uploadType == 'testimony') {
            obj.uploadTestimonyLogo()
          }
          else {
            obj.uploadBackGround()
          }
        else {
          this.loading = false
          this.profileService.clearStoreCache(this.transparency.seoUrl).subscribe()
          this.notificationBuilder.showNotification('success', 1000, 'Seus dados foram alterados com sucesso')
        }
      } else {
        this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos seus dados')
      }
    })
  }

  fileChangeEvent(fileInput: any, uploadType: string) {
    //Clear Uploaded Files result message
    this.filesToUpload = <Array<File>>fileInput.target.files;
    this.uploadType = uploadType;

    for (let i = 0; i < this.filesToUpload.length; i++) {
      this.selectedFileNames.push(this.filesToUpload[i].name);
    }
  }

  uploadBackGround() {
    debugger
    if (this.filesToUpload.length > 0) {
      this.isLoadingData = true;

      let formData: FormData = new FormData();

      for (var i = 0; i < this.filesToUpload.length; i++) {
        formData.append('uploadedFiles', this.filesToUpload[i], this.filesToUpload[i].name);
      }

      formData.append('seoName', this.transparency.seoUrl)
      formData.append('polenTest', "true")

      let apiUrl = Configuration.apiUrl + "api/customize/SaveTransparencyBG?seoName=" + this.transparency.seoUrl + '&polenTest=true';
      //let apiUrl = "http://localhost:49787/api/customize/SaveTransparencyBG?seoName=" + this.transparency.seoUrl + '&polenTest=true';

      this.httpService.post(apiUrl, formData).subscribe({
        next: (response) => {
          console.log(response)
        },
        error: err => {
          console.error(err);
          this.isLoadingData = false;
        },
        complete: () => {
          this.isLoadingData = false,
            this.selectedFileNames = [];
          this.filesToUpload = [];
          this.loading = false
          this.profileService.clearStoreCache(this.transparency.seoUrl).subscribe()
          this.notificationBuilder.showNotification('success', 1000, 'Seus dados foram alterados com sucesso')
          window.location.reload()
        }
      });
    }
  }

  uploadTestimonyLogo() {
    debugger
    if (this.filesToUpload.length > 0) {
      this.isLoadingData = true;

      let formData: FormData = new FormData();

      for (var i = 0; i < this.filesToUpload.length; i++) {
        formData.append('uploadedFiles', this.filesToUpload[i], this.filesToUpload[i].name);
      }

      formData.append('seoName', this.transparency.seoUrl)
      formData.append('polenTest', "true")

      let apiUrl = Configuration.apiUrl + "api/customize/SaveTestimonyLogo?seoName=" + this.transparency.seoUrl + '&polenTest=true';
      //let apiUrl ="http://localhost:49787/api/customize/SaveTestimonyLogo?seoName=" + this.transparency.seoUrl + '&polenTest=true';

      this.httpService.post(apiUrl, formData).subscribe({
        next: (response) => {
          console.log(response)
        },
        error: err => {
          console.error(err);
          this.isLoadingData = false;
        },
        complete: () => {
          this.isLoadingData = false,
            this.selectedFileNames = [];
          this.filesToUpload = [];
          this.loading = false
          this.profileService.clearStoreCache(this.transparency.seoUrl).subscribe()
          this.notificationBuilder.showNotification('success', 1000, 'Seus dados foram alterados com sucesso')
          window.location.reload();
        }
      });
    }
  }

  showDeleteModal(id) {
    this.idDelete = id;
    this.ngxSmartModalService.getModal('deleteModal').open();
  }

  removeImage() {
    debugger
    this.profileService.deleteImage(this.idDelete).subscribe(data => {
      console.log(data);
      if (data.sucess) {
        this.profileService.clearStoreCache(this.transparency.seoUrl).subscribe()
        this.idDelete = "";
        this.notificationBuilder.showNotification('success', 1000, 'Sua imagem foi deletada com sucesso');
      }
      window.location.reload();
    })

  }

  //atualiza o modal
  updateRelationInfos(e) {
    this.transparency.relationInfos.forEach(function (cat) {
      if (cat.id == e.target.id) {
        cat.isSelected = e.target.checked;
      }
    });
  }



  //modal popup

  showOnboardingVideo() {
    this.showWelcome = true;
  }

  goTo(step: string) {
    switch (step) {
      case "step1":
        this.step1 = true;
        this.step2 = this.step2 = false;
        break;
      case "step2":
        this.step2 = true;
        this.step1 = this.step2 = false;
        break;

    }
  }

  nextStep() {
    if (this.step1) {
      this.step1 = false;
      this.step2 = true;
    } else if (this.step2) {
      this.step2 = false;
    }
  }


  openTutorial() {
    this.step1 = true;
    this.step2 = false;
    this.showWelcome = true;
  }

  showModal(id: string) {
    this.ngxSmartModalService.open(id)
  }
}


